import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetAllBaseRole = () => {
  const [loading, setLoading] = useState(true);
  const [roleList, setRoleList] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getRoleList = () => {
    setLoading(true);

    axiosClient
      .get('SettingAccount/Role/GetAllBaseRole')
      .then(res => {
        if (res.status === 200) {
          setRoleList(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getRoleList, loading, roleList];
};

export default useGetAllBaseRole;
